import Analytics from '@/services/analytics'

// Traits we no longer send. RudderStack merges every identify into the traits it
// already stored, so users who have them keep them in the rl_trait cookie, and
// the klaviyo destination copies them into __kla_id, until they are removed.
export const DEPRECATED_TRAIT_KEYS = [
  '_firstPage',
  'Recently Viewed Product IDs',
  // removed from useABTestV2.ts
  'test_participant_id',
  // commented out in ProductVerificationPopup.vue
  'verification_popup_opened',
  'last_upload_count',
]

// use on traits coming from the api, otherwise the old values are sent back
export function omitDeprecatedTraits<T extends Record<string, any>>(traits: T) {
  const result: Record<string, any> = { ...traits }
  DEPRECATED_TRAIT_KEYS.forEach((key) => delete result[key])
  return result as T
}

// remove the deprecated traits from the traits RudderStack stored for this user
export function removeDeprecatedTraitsFromStorage() {
  Analytics.excuteOnReady(() => {
    try {
      // this is the traits object of the sdk itself (not a copy)
      const traits = Analytics.getUserTraits()
      if (!traits) return
      const keys = DEPRECATED_TRAIT_KEYS.filter((key) => key in traits)
      if (!keys.length) return

      keys.forEach((key) => delete traits[key])
      // the sdk only writes the traits cookie on identify, so identify once
      Analytics.identify({ ...traits })
    } catch (e) {}
  })
}
